/**
 * Parses a date string in the format "dd.MM.yyyy" and returns a Date object.
 *
 * @param {string} dateString - The date string to parse.
 * @returns {Date} The parsed date.
 *
 * // Example 1: Parsing a valid date string
 * const date1 = parseDateString("01.01.2022");
 * // Outputs: 2022-01-01T00:00:00.000Z
 *
 * // Example 2: Parsing a date string with single digit day and month
 * const date2 = parseDateString("1.1.2022");
 * // Outputs: 2022-01-01T00:00:00.000Z
 *
 * // Example 3: Parsing an invalid date string
 * const date3 = parseDateString("This is not a date");
 * // Outputs: Invalid Date
 */
export const parseDateString = (dateString: string): Date => {
  const [year, month, day] = dateString.split("-");
  const parsedDay = parseInt(day, 10);
  const parsedMonth = parseInt(month, 10);
  const parsedYear = parseInt(year);
  return new Date(parsedYear, parsedMonth - 1, parsedDay);
};
